import { formatNumber } from '@/platform/lib/utils';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend, Tooltip);

const COLORS = ['#06224c', '#74cdff', '#f59e0b', '#10b981', '#ef4444'];

const ReportPie = ({ rows }) => {
    if (!rows || rows.length === 0) {
        return null;
    }

    const items = rows.slice(0, -1);

    return (
        <Pie
            data={{
                labels: items.map(row => row.label),
                datasets: [
                    {
                        data: items.map(row => row.value || 0),
                        backgroundColor: COLORS,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 10,
                            boxHeight: 10,
                            usePointStyle: true,
                        },
                    },
                    tooltip: {
                        callbacks: {
                            title: context => formatNumber(context[0].raw),
                            label: context => {
                                const total = context.dataset.data.reduce(
                                    (sum, point) => sum + point,
                                    0
                                );

                                return total > 0
                                    ? `${formatNumber((context.raw / total) * 100)}%`
                                    : '0%';
                            },
                        },
                    },
                },
            }}
        />
    );
};

export default ReportPie;
